import comp from "./MarksComponent";
export default comp;
